import React from 'react';
import Component from 'BaseComponent';
import autobind from 'autobind-decorator';

const steps = '⠋⠙⠹⠸⠼⠴⠦⠧⠇⠏';

export default class TextSpinner extends Component {
  state = {
    step: 0,
  };

  componentDidMount() {
    this.interval = setInterval(this.changeStep, 70);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  @autobind
  changeStep() {
    this.setState({
      step: (this.state.step + 1) % steps.length,
    });
  }

  render() {
    return (
      <span>{steps.charAt(this.state.step)}</span>
    );
  }
}




// WEBPACK FOOTER //
// ./app/components/TextSpinner.jsx